export const FEATURE_SERIAL_NUMBER_GENERATE = "serial number generate";
export const FEATURE_SERIAL_NUMBER_ASSIGN = "serial number assign";
